<script setup>
const attrs = useAttrs()
const emit = defineEmits(['focus'])
</script>

<template>
  <FormKit
    v-bind="attrs"
    :classes="{
      input: 'floating__input',
    }"
    @focus="emit('focus')"
  >
    <template #label="{ value }">
      <label
        :for="attrs.id"
        class="floating__label"
        :class="{ 'has-value': value }"
      >
        {{ attrs.label }}
      </label>
    </template>
  </FormKit>
</template>
